module.exports = __webpack_public_path__ + "img/IMG_6984_L_Wood_MockedUp.f43dd5c7.jpg";